const URLs = {
  DEV: 'https://dev-gateway.leegality.com/auth/login/success',
  PREPROD: ' https://preprod-gateway.leegality.com/auth/login/success',
  SANDBOX: ' https://sandbox-gateway.leegality.com/auth/login/success',
  PROD: 'https://api-gateway.leegality.com/auth/login/success',
  LOCAL: 'https://dev-gateway.leegality.com/auth/login/success',
};

const EnvTypes = {
  DEV: 'dev',
  PREPROD: 'preprod',
  SANDBOX: 'sandbox',
  PROD: 'prod',
  LOCAL: 'local',
};

const successLoginRedirectUrls = {
  [EnvTypes.PROD]: URLs.PROD,
  [EnvTypes.PREPROD]: URLs.PREPROD,
  [EnvTypes.SANDBOX]: URLs.SANDBOX,
  [EnvTypes.LOCAL]: URLs.LOCAL,
  [EnvTypes.DEV]: URLs.DEV,
};

export const getSuccessLoginRedirectUrl = () => {
  const env = process.env.REACT_APP_STAGE || EnvTypes.LOCAL;
  return successLoginRedirectUrls[env];
};
